module.exports = __webpack_public_path__ + "static/media/car_2.af718298.svg";